<template>
    <div class="main-layout">

        <div class="ban">
            <!-- <img src="@/assets/img/banner.jpg" alt="배너" class="dn">
            <img src="@/assets/img/banner.jpg" alt="배너" class="mob_ban"> -->
            <router-link v-if="isSubmittable && role == 'SPEAKER'" to="/applyforlecturesNew/0/lecture" class="to_sketchbtn"><span>Apply for Lecture</span> <i class="pi pi-arrow-right"></i></router-link>
            <!-- <router-link v-if="isSubmittable && role == 'PARTICIPANTS' || role == 'FREECOMM'" to="/applyforlecturesNew/0/abstract" class="to_sketchbtn"><span>Apply for Lecture</span> <i class="pi pi-arrow-right"></i></router-link> -->
            <div class="container ">
                <img src="@/assets/img/ban_logo.png" alt="" class="ban_logobox">
            </div>
        </div>

        <div class="welcome">
            <div class="container">
                <div class="welcomebox">
                    <h2>“Welcome to KOREADERMA 2025”</h2>
                    
                    <div class="greet">
                        <p><b>Dear Colleagues and Friends, </b>On behalf of the Association of Korean Dermatologists, we are delighted to introduce KOREADERMA 2025, one of Asia’s top dermatological symposiums. The event will take place from October 31 to November 2, 2025, at Coex Magok, Seoul.</p>

                        <p>As the leading international aesthetic dermatology conference in Asia, KOREADERMA has established itself as a premier platform for sharing cutting-edge insights, exploring innovations, and discussing emerging trends. Now in its 6th year, the event provides invaluable expertise not only in aesthetic dermatology but also in K-Beauty and the medical device industries.</p>

                        <p>Last year, the event successfully brought together 3,200 participants from 60 countries. Building on that success, KOREADERMA 2025 is ready to welcome an even larger global audience. This year’s event will feature a meticulously curated program, exceptional networking opportunities, and groundbreaking academic exchanges.</p>

                        <p>We look forward to your participation in KOREADERMA 2025 and to welcoming you to Seoul. Let us expand our academic and clinical knowledge, build meaningful connections, and shape the dynamic future of aesthetic dermatology together.</p>

                        <p>Warm regards,</p>
                    </div>

                    <div class="greetimgwrap">
                        <div class="greetimgbox">
                            <div class="greetimg">
                                <img src="@/assets/img/greet1-1.jpg">
                            </div>
                            <div class="greetext">
                                <h4>Hangrae Cho, M.D., Ph.D</h4>
                                <p>President,<br>
                                    the Association of Korean Dermatologists</p>
                            </div>
                        </div>
                        <div class="greetimgbox">
                            <div class="greetimg">
                                <img src="@/assets/img/greet1-2.jpg">
                            </div>
                            <div class="greetext">
                                <h4>Hongseok Yoon, M.D., Ph.D</h4>
                                <p>Secretary General,<br>
                                    KOREADERMA 2025</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="countingBox">
                    <div class="counttitle">
                        <h1>KOREADERMA 2025</h1>
                    </div>
                    <div class="counters-box">
                        <div class="counter-box">
                            <div class="counter-box-container">
                                <div class="content-box-counter">
                                    <span class="display-counter" data-target="60">0</span>
                                    <div class="counter-box-content">COUNTRIES</div>
                                </div>
                            </div>
                        </div>
                        <div class="counter-box">
                            <div class="counter-box-container">
                                <div class="content-box-counter">
                                    <span class="display-counter" data-target="3200">0</span>
                                    <div class="counter-box-content">TOTAL PARTICIPANTS</div>
                                </div>
                            </div>
                        </div>
                         <div class="counter-box">
                            <div class="counter-box-container">
                                <div class="content-box-counter">
                                    <span class="display-counter" data-target="70">0</span>
                                    <div class="counter-box-content">SESSION</div>
                                </div>
                            </div>
                        </div>
                        <div class="counter-box">
                            <div class="counter-box-container">
                                <div class="content-box-counter">
                                    <span class="display-counter" data-target="281">0</span>
                                    <div class="counter-box-content">LECTURES</div>
                                </div>
                            </div>
                        </div>
                        <div class="counter-box">
                            <div class="counter-box-container">
                                <div class="content-box-counter">
                                    <span class="display-counter" data-target="122">0</span>
                                    <div class="counter-box-content">SPONSORS</div>
                                </div>
                            </div>
                        </div>
                         <div class="counter-box">
                            <div class="counter-box-container">
                                <div class="content-box-counter">
                                    <span class="display-counter"  data-target="214">0</span>
                                    <div class="counter-box-content">BOOTHS</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="Remarks">
            <div class="fullwidth-video">
                <video preload="auto" autoplay muted loop playsinline class="background-video">
                    <source src="../../assets/video/remarksbg.mp4" type="video/mp4">
                </video>
            </div>
            <div class="conts">
                <div class="counttitle snstitle">
                    <h1>Remarks from<br>KOREADERMA 2025</h1>
                </div>
                <div class="sns_slider" >
                    <swiper
                        class="custom-carousel-wrapper"
                        ref="swiper"
                        :modules="modules"
                        :slidesPerView="5.5"
                        :spaceBetween="20"
                        :loop="true"
                        :centeredSlides="true"
                        :autoplay="{ delay: 3000, disableOnInteraction: false }"
                        :scrollbar="{ draggable: true }"
                        :grabCursor="true"
                        :breakpoints="breakpoints"
                        >
                        <swiper-slide v-for="(item, index) in sns_items" :key="index">
                            <div class="item">
                            <div class="sp-testimonial-pro">
                                <div class="tpro-client-testimonial">
                                <div class="tpro-testimonial-text">
                                    <p>{{ item.cont }}</p>
                                </div>
                                </div>
                                <h4 class="tpro-client-name">{{ item.name }}</h4>
                                <div class="tpro-client-location">{{ item.location }}</div>
                            </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>

                <div class="f_titBox">
                    If you want to know what’s going on at Korea Derma,<br>
                        check out our social media channels below!
                </div>
                <div class="snsbox">
                    <a class="snsa" href="https://www.facebook.com/profile.php?id=100089262256062" target="_blank">
                        <img src="@/assets/img/sns1.png">
                    </a>
                    <a class="snsa" href="https://www.instagram.com/koreaderma_official" target="_blank">
                        <img src="@/assets/img/sns2.png">
                    </a>
                    <a class="snsa" href="https://www.youtube.com/@%EB%8C%80%ED%95%9C%ED%94%BC%EB%B6%80%EA%B3%BC%EC%9D%98%EC%82%AC%ED%9A%8C" target="_blank">
                        <img src="@/assets/img/sns3.png">
                    </a>
                </div>
            </div>
            
        </div>

        <div class="Scientific">
            <div class="counttitle snstitle blacktitle">
                <h1>Scientific Partners</h1>
            </div>
            <div class="partWrap">
                <div class="mainpart">
                    <div class="partbox">
                        <div class="partimg">
                            <a href="http://www.lasermed.org.tw/index.html" target="_blank">
                                <img src="@/assets/img/part1-1.jpg">
                            </a>
                        </div>
                        <div class="parttxt">
                            <a href="http://www.lasermed.org.tw/index.html" target="_blank">Laser and Photonics Medicine<br>
                                Society of Taiwan
                            </a>
                        </div>
                    </div>
                    <div class="partbox partboxright">
                        <div class="partimg">
                            <img src="@/assets/img/part2.jpg">
                        </div>
                        <div class="parttxt">Mongolian Society<br>
                            for Investigative Dermatology
                        </div>
                    </div>
                    <div class="partbox">
                        <div class="partimg">
                            <img src="@/assets/img/part3.jpg">
                        </div>
                        <div class="parttxt">Vietnamese Society of<br>
                            Dermatology and Venereology
                        </div>
                    </div>
                    <div class="partbox partboxright">
                        <div class="partimg">
                            <a href="https://perdoski.id/" target="_blank">
                                <img src="@/assets/img/part4.jpg">
                            </a>
                        </div>
                        <div class="parttxt">
                            <a href="https://perdoski.id/" target="_blank">Indonesian Society of<br>
                                Dermatology and Venereology
                            </a>
                        </div>
                    </div>
                    <div class="partbox partboxlast">
                        <div class="partimg">
                            <a href="https://aesthet-derm.org/" target="_blank">
                                <img src="@/assets/img/part5.jpg">
                            </a>
                        </div>
                        <div class="parttxt">
                            <a href="https://aesthet-derm.org/" target="_blank">Japanese
                                Society of<br>
                                Aesthetic Dermatology
                            </a>
                        </div>
                    </div>
                    <div class="partbox partboxright"></div>
                </div>
            </div>
        </div>
        
        <div class="Collaboration">
           <div class="counttitle snstitle blacktitle">
                <h1>Special Collaboration</h1>
            </div>
            <div class="mainbans">
                <a href="https://www.imcas.com/en/exhibit/imcas-asia-2025" target="blank">
                    <img src="@/assets/img/600x160_asia_2025.jpg">
                </a>
            </div>


        </div>

         <div class="Committee">

            <div class="counttitle snstitle blacktitle">
                <h1>Committee Members</h1>
            </div>
            
            <div class="commitbtn">
                <button type="button" @click="openCommitteeModal">
                    <span>View List</span>
                    <i class="pi pi-angle-right"></i>
                </button>
            </div>

            <div class="commitblue">
                <h1>COMMITTEE</h1>
            </div>

            <div class="commitpink commitnam">
                <h2>Scientific Committee</h2>
            </div>

            <div class="commitso">
                <h2>General Chair</h2>
            </div>

            <div class="commit1 commitone">
                <div class="commitwrap">
                    <div class="commitbox">
                        <div class="comimg">
                            <img src="@/assets/img/commit1-1.jpg">
                        </div>
                        <div class="comtxt">Hongseok Yoon</div>
                    </div>
                </div>
            </div>

            <div class="commitso">
                <h2>Chair of Academic Committee</h2>
            </div>

            <div class="commit1 commitone">
                <div class="commitwrap">
                    <div class="commitbox">
                        <div class="comimg">
                            <img src="@/assets/img/chang01.jpg">
                        </div>
                        <div class="comtxt">Chang-Keun Oh</div>
                    </div>
                </div>
            </div>

            <div class="commitso">
                <h2>Academic Director</h2>
            </div>

            <div class="commit1 committwo">
                <div class="commitwrap">
                    <div class="commitbox commitboxleft">
                        <div class="comimg">
                            <img src="@/assets/img/commit1-3.jpg">
                        </div>
                        <div class="comtxt">Jung Min Bae</div>
                    </div>
                    <div class="commitbox commitboxright">
                        <div class="comimg">
                            <img src="@/assets/img/commit1-4.jpg">
                        </div>
                        <div class="comtxt">Do Young Rhee</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 팝업 -->
        <Dialog v-model:visible="popupView" header="&nbsp;" modal   class="custom-dialog">
            <div class="content">
                <img src="@/assets/img/KD2024_eDM_thx_700x_1206_b.jpg" alt="">
            </div>
        
            <div class="footer">
                <button type="button" @click="hidePopupForToday" class="btn not_today">
                    오늘 하루 보지 않음
                </button>
             </div>
        </Dialog>

        <!-- View List 모달 -->
         <Dialog v-model:visible="committeeModal" header="&nbsp;" modal :style="{ width: '50rem' }"  :breakpoints="{ '1500px': '60vw', '991px': '80vw', '580px': '90vw' }"  class="custom-dialog">
       
            <img src="@/assets/img/committee.jpg" alt="">
        </Dialog>
    </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import Dialog from 'primevue/dialog';
import { supabase } from '@/API/supabase';

export default {
    name: 'home',
    data() {
        return {
            modules: [Autoplay, Pagination, Navigation],
            sns_items: [
                { id: 1, cont: 'You did a very good job already! just lunch is not so heavy, but I am ok still', name: 'Grace Waworuntu', location: 'Indonesia' },
                { id: 2, cont: 'I enjoyed the meeting and met some a lot of experts. Thank you', name: 'Eran Krieger', location: 'Israel' },
                { id: 3, cont: 'I thought it was a very good and high quality meeting', name: 'Michael H Gold', location: 'USA' },
                { id: 4, cont: 'A heartfelt thank you to the committee members for creating such a memorable experience. I’m already looking forward to KoreaDerma 2025!', name: 'Lynhda Nguyen', location: 'Germany' },
                { id: 5, cont: 'All was perfect and we’ll planned.', name: 'Swapnil Bumb', location: 'India' },
                { id: 6, cont: 'Best Aesthetic Conference!', name: 'Arah Margarita Ty', location: 'Philippines' },
                { id: 7, cont: 'You’re a wonderful team, a family-like atmosphere yet thoroughly professional. It’s difficult to achieve but you’ve done it so well! ', name: 'Aseem Sharma ', location: 'India' },
                { id: 8, cont:'You’re a wonderful team, a family-like atmosphere yet thoroughly professional. It’s difficult to achieve but you’ve done it so well! ', name:'Aseem Sharma ',location:'India'  },
            ],
            breakpoints: {
                '320': {
                    slidesPerView: 1.5,
                    spaceBetween: 10,
                },
                '640': {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                '768': {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                '1024': {
                    slidesPerView: 5.5,
                    spaceBetween: 20,
                },
            },
            popupView: false,
            committeeModal: false,
            role: '',
            useruid: '',
            isSubmittable: false,
        }
    },
    components: {
        Swiper,
        SwiperSlide,
        Dialog
    },
    async mounted() {

        var user = this.$store.getters['user'];
        if(user.loggedIn){
            this.useruid = user.data.useruid;
            await this.getUserInfo();

            this.event_code = await this.getEventCode();
            this.checkApplicationDate();
        }

        const storedDate = localStorage.getItem('koreaderma_hidePopupDate');
        if (storedDate === this.getTodayDate()) {
            this.popupView = false; // 저장된 날짜가 오늘과 같으면 팝업 숨김
        }else{
            this.popupView = false; // 잠시 팝업 숨김
        }

        window.addEventListener("scroll", this.handleScroll);
    },
    beforeUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {

        // 이벤트 코드 가져오기
        async getEventCode() {
            let query = supabase
                .from('Event')
                .select('*')
                .eq('active', true)
                .order('event_code', { ascending: false })
                .limit(1)
                .single();

            const { data, error } = await query;

            // console.log(data);
            if(data){
                this.activatedEventCodeInfo = data;
                return data.event_code;
            }else{
                return new Date().getFullYear().toString();
            }
        },

        // 사용자 정보 가져오기
        async getUserInfo(){
            try {
                const { data, error } = await supabase
                .from('UserInfo')
                .select('role')
                .eq('useruid', this.useruid)
                .single();

                if (error) {
                    console.error('사용자 정보를 불러오는 중 오류 발생:', error);
                } else {
                    // console.log("UserInfo : ",data);
                    var userData = data;
                    this.role = userData.role;
                }
            } catch (error) {
                console.error('사용자 정보를 불러오는 중 오류 발생:', error);
            }
        },

        // 신청기간 체크
        async checkApplicationDate(){
            var today = new Date();
            today.setHours(today.getHours() + 9);
            today = new Date(today);

            const { data, error } = await supabase
                .from('Event')
                .select('*')
                .eq('event_code', this.event_code.toString())
                .single();

            if (error) {
                console.log('error', error);
            } else {
                // console.log(data);
                // console.log(this.role)

                if(this.role == "SPEAKER"){
                    var lec_sdate = new Date(data.lec_sdate);
                    var lec_edate = new Date(data.lec_edate);
                    lec_sdate.setHours(0, 0, 0);
                    lec_edate.setHours(23, 59, 59);

                    if(today < lec_sdate || today > lec_edate){
                        this.isSubmittable = false;
                    }else{
                        this.isSubmittable = true;
                    }
                }else{
                    var abstract_sdate = new Date(data.abstract_sdate);
                    var abstract_edate = new Date(data.abstract_edate);
                    if(today < abstract_sdate || today > abstract_edate){
                        this.isSubmittable = false;
                    }else{
                        this.isSubmittable = true;
                    }
                }
                
                return true;
            }
        },

        // 스크롤 이벤트 
        handleScroll() {
            const triggerPoint = window.innerHeight * 0.8; // 뷰포트 높이의 80% 위치
            const counters = document.querySelectorAll(".display-counter");
            counters.forEach((counter) => {
                if (counter.counted) return; // 카운트가 완료된 경우 중단
                const counterPosition = counter.getBoundingClientRect().top;
                if (counterPosition < triggerPoint) {
                    counter.counted = true; // 카운트 중복 실행 방지
                    this.startCounting(counter);
                }
            });

        },

        // 카운트 시작
        startCounting(counter) {
            const target = +counter.getAttribute("data-target");
            const duration = 2000; // 2초
            const step = Math.ceil(target / duration * 1000 / 60); // 1프레임당 증가량
            let count = 0;
            const timer = setInterval(() => {
                count += step;
                counter.textContent = count.toLocaleString();
                if (count >= target) {
                    counter.textContent = target.toLocaleString();
                    clearInterval(timer);
                }
            }, 16.7);
        },

        // View List 버튼 클릭시 모달창 열기
        openCommitteeModal() {
            this.committeeModal = true;
        },

        // 팝업창 오늘 하루 보지 않기
        hidePopupForToday(){
            localStorage.setItem('koreaderma_hidePopupDate', this.getTodayDate());
            this.popupView = false;
        },
        
        // 오늘 날짜 구하기
        getTodayDate(){
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1;
            const day = today.getDate();
            // 날짜 형식 YYYY-MM-DD
            return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
        },
    },
};
</script>

